<template>
 <div>
    <img src="@/assets/404.png">
 </div>
</template>

<script setup>
 
</script>

<style scoped lang="less">
</style>